// extracted by mini-css-extract-plugin
module.exports = {"root":"Embed_root__0K2nh","loading":"Embed_loading__9FC54","enableConsent":"Embed_enableConsent__k_6P_","consentCta":"Embed_consentCta__wT3vq","text":"Embed_text__2AOaI"};